import React from "react"
import { twMerge } from "tailwind-merge"
import { Link } from "gatsby"

const NavButton = props => {
  const active = color => {
    if (color === "gray") {
      return "!bg-slate-500 !text-slate-50 !cursor-default"
    }
    if (color === "pink") {
      return "!bg-pink-500 !text-pink-50 !cursor-default"
    }
    if (color === "red") {
      return "!bg-rose-500 !text-rose-50 !cursor-default"
    }
    if (color === "orange") {
      return "!bg-orange-500 !text-orange-50 !cursor-default"
    }
    if (color === "yellow") {
      return "!bg-amber-500 !text-amber-50 !cursor-default"
    }
    if (color === "green") {
      return "!bg-emerald-500 !text-emerald-50 !cursor-default"
    }
    if (color === "teal") {
      return "!bg-teal-500 !text-teal-50 !cursor-default"
    }
    if (color === "blue") {
      return "!bg-blue-500 !text-blue-50 !cursor-default"
    }
    if (color === "purple") {
      return "!bg-violet-500 !text-violet-50 !cursor-default"
    }
    if (color === "indigo") {
      return "!bg-indigo-500 !text-indigo-50 !cursor-default"
    }
  }

  return (
    <Link
      onClick={props.onClick}
      to={props.to}
      activeClassName={active(props.color)}
      className={twMerge([
        "group",
        "inline-flex items-center px-2.5 py-0.5 text-xs font-medium leading-4",
        props.square ? "rounded-sm" : "rounded-full",
        props.color === "gray" &&
          "bg-slate-100 text-slate-800 hover:bg-slate-200",
        props.color === "pink" && "bg-pink-100 text-pink-800 hover:bg-pink-200",
        props.color === "red" && "bg-rose-100 text-rose-800 hover:bg-rose-200",
        props.color === "orange" &&
          "bg-orange-100 text-orange-800 hover:bg-orange-200",
        props.color === "yellow" &&
          "bg-amber-100 text-amber-800 hover:bg-amber-200",
        props.color === "green" &&
          "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
        props.color === "teal" && "bg-teal-100 text-teal-800 hover:bg-teal-200",
        props.color === "blue" && "bg-blue-100 text-blue-800 hover:bg-blue-200",
        props.color === "purple" &&
          "bg-violet-100 text-violet-800 hover:bg-violet-200",
        props.color === "indigo" &&
          "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
        props.className,
      ])}
    >
      {props.children}
    </Link>
  )
}

export default NavButton
